<script lang="ts">
  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";

  // types
  import type { PaymentTransferType } from "@shared/types/Invoice";

  // props
  export let payment: PaymentTransferType;

</script>

<div class="fizz-space-between">
  <dt>Original invoice amount</dt>
  <dd>
    <FormatMoney input={payment.payment_invoice.original_amount_due} formatType={"5"} />
  </dd>
</div>
{#each payment?.applied_credit_transfers as transfer}
  <div class="fizz-space-between">
    <dt>
      Credit #{transfer.credit_redemptions.find(
        credit => credit.payment_transfer_id == transfer.id.toString()
      ).credit_invoice.invoice_reference_id} applied
    </dt>
    <dd><FormatMoney input={-transfer.amount} formatType={"5"} /></dd>
  </div>
{/each}
<div class={"fizz-space-between " + `payment_detail_total_${payment.id}`}>
  <dt><strong>Total Payment</strong></dt>
  <dd>
    <strong>
      {#if payment.settlement_status === "settled"}
        <FormatMoney input={payment.net_amount} formatType={"5"} />
      {:else}
        Pending
      {/if}
    </strong>
  </dd>
</div>
